module.exports = __webpack_public_path__ + "assets/img/kv-925e88fa.jpg";